import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "github",
  "name": "GitHub",
  "category": "integrations",
  "description": "Interact with GitHub repositories, issues, and pull requests",
  "icon": "siGithub",
  "iconType": "simple-icon",
  "color": "gray",
  "version": "1.5.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "GitHub",
    "color": "#24292e"
  },
  "credentials": [
    {
      "name": "githubOAuth2",
      "required": true,
      "displayName": "GitHub OAuth2"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "github",
    "git",
    "repository",
    "code",
    "version-control"
  ],
  "comingSoon": true
};

export default definition;
